import { ChartType } from "../../../../../store/enums";

const Config = {
	EXPORT_WIDTH: 1269,
	EXPORT_HEIGHT: 880,
	LEFT_COLUMN_WIDTH: 613,
	OUTER_PADDING: 40,
	BORDER_RADIUS: 8,
	INNER_PADDING: 16,
	INNER_GAP: 8,
	FONT_SIZE: 16,
	LINE_HEIGHT: 24,
	AVATAR_DIAMETER: 20,
	ROTATED_LABELS_EXTRA_SPACE: 16,
	CHART_DIMENSIONS: {
		// These have to be configured seperately for each chart type since the layout for each is unique
		[ChartType.ScatterChart]: {
			width: 1173,
			// height includes the space available for the legend since the legend height is dynamic
			height: 704,
			ADDITIONAL_PADDING_LEFT: 0,
			ADDITIONAL_HEIGHT_BOTTOM: 0,
		},
		[ChartType.NineBox]: {
			width: 1173,
			height: 704,
			ADDITIONAL_PADDING_LEFT: 0,
			ADDITIONAL_HEIGHT_BOTTOM: -24,
		},
		[ChartType.BarChart]: {
			width: 1173,
			height: 724,
			ADDITIONAL_PADDING_LEFT: 16,
			ADDITIONAL_HEIGHT_BOTTOM: 60,
		},
		[ChartType.ColumnChart]: {
			width: 1173,
			height: 724,
			ADDITIONAL_PADDING_LEFT: 0,
			ADDITIONAL_HEIGHT_BOTTOM: 76,
		},
		[ChartType.HistogramChart]: {
			width: 1173,
			height: 724,
			ADDITIONAL_PADDING_LEFT: 16,
			ADDITIONAL_HEIGHT_BOTTOM: 60,
		},
		[ChartType.TrendlineChart]: {
			width: 1173,
			height: 724,
			ADDITIONAL_PADDING_LEFT: 0,
			ADDITIONAL_HEIGHT_BOTTOM: 76,
		},
	},
};
export default Config;
